import React from 'react';
import ReactDOM from 'react-dom/client';  // Import from 'react-dom/client' for React 18
// import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';


// Create root using ReactDOM.createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app inside the root
root.render(
  <Router>
    <App />
  </Router>
);
